import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Row from "components/Row";
import PayModal from "./PayModal";
import ExamCard from "./ExamCard";
import Page from "components/Page";
import { createQuiz } from "./firebase";
import { Title } from "components/Title";
import { getExamAction } from "./actions";
import { useActions } from "helpers/useActions";
import { Container } from "components/Container";
import Modal, { useModal } from "components/Modal";
import HeaderBanner from "components/headerBanner/HeaderBanner";
import FullScreenLoader from "components/Loaders/FullScreenLoader";
import LoginAlertModal from "components/loginModal/LoginAlertModal";

export default function ExamPage({ history }) {
  const exams = useSelector(state => state.examState.exams);
  const loading = useSelector(state => state.examState.loading);
  const firestoreUser = useSelector(state => state.authState.firestoreUser);
  const dispatch = useDispatch();
  const [exam, selectExam] = useState();
  const modal = useModal();

  const getExams = useActions(getExamAction);

  useEffect(() => {
    getExams();
    // eslint-disable-next-line
  }, []);

  if (loading) return <FullScreenLoader />;

  // if (!Object.keys(exams).length) {
  //   return 'No exam';
  // }

  function startExam(exam) {
    if (exam.quiz) {
      history.push("/exam/" + exam.examKey);
    } else {
      selectExam(exam);
      modal.open();
    }
  }

  function setUpAndStartExam() {
    createQuiz(exam.paperKey, exam.name, exam.examKey).then(quiz => {
      dispatch({ type: "GET_USER_QUIZ", payload: quiz });
      history.push("/exam/" + exam.examKey);
    });
  }

  return (
    <React.Fragment>
      <HeaderBanner title="Exams" subtitle="Learn about upcoming exams" />
      <Page>
        <Container flexDirection="column">
          <Title>Upcoming Exam</Title>
          {!Object.keys(exams).length ? (
            <h1>No Exam</h1>
          ) : (
            <Row flexDirection="column">
              {Object.values(exams).map(exam => (
                <ExamCard key={exam.examKey} exam={exam} onStart={startExam} />
              ))}
            </Row>
          )}
        </Container>
      </Page>
      <Modal {...modal.props}>
        {firestoreUser.anon ? (
          <LoginAlertModal onClick={() => modal.close()} history={history} />
        ) : (
          <PayModal onSuccess={setUpAndStartExam} onClick={modal.close} />
        )}
      </Modal>
    </React.Fragment>
  );
}
